module.exports = __webpack_public_path__ + "static/media/31JFA1.2b89e61e.jpg";